import React from 'react'
import { Modal, Spinner } from 'react-bootstrap'


const LoaderModal = ({ showLoader, loaderData }) => {

    return (
        <Modal show={showLoader} size="sm" style={{ paddingTop: "200px", background: "#00000070" }}>
            <div className="d-flex flex-column align-items-center py-4">
                <Spinner animation="border" style={{ color: "#5c518b" }} />
                <p className="mt-3 mb-0">{loaderData ? loaderData : "Please Wait..."}</p>
            </div>
        </Modal>
    )
}

export default LoaderModal
